import React, { useMemo, useState, useEffect } from "react";
import { Dropdown } from "antd";
import { useTranslation } from "react-i18next";

import NotificationBlock from "./NotificationBlock";

import { ReactComponent as TransNotifIcon } from "../../img/default-svg/bell.svg";
import { ReactComponent as TransNotifIconInex } from "../../img/inex/bell.svg";
import { ReactComponent as TransNotifIconInsta } from "../../img/instaXchange/bell.svg";
import { ReactComponent as TransNotifIconCoinera } from "../../img/coinera/bell.svg";
import { ReactComponent as CloseIcon } from "../../img/default-svg/close-black.svg";
import { ReactComponent as CloseIconInex } from "../../img/inex/close-black-inex.svg";
import { ReactComponent as CloseIconInsta } from "../../img/instaXchange/close-black-insta.svg";
import { ReactComponent as CloseIconCoinera } from "../../img/coinera/close-black-coinera.svg";

import { identity } from "../../utils/getIdentity";
import { getTransactionNotification, patchTransactionNotifications } from "../../redux/actions/transactions";

import "./style.scss";
import { connect } from "react-redux";
import Button from "../Button";

const TransactionNotification = ({ notification, merchantId, getTransactionNotification, patchTransactionNotifications }) => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  const closeIcon = {
    cpay: <CloseIcon onClick={() => setIsVisible(false)} className="notification-dropdown__close" />,
    nfg: <CloseIcon onClick={() => setIsVisible(false)} className="notification-dropdown__close" />,
    finvaro: <CloseIcon onClick={() => setIsVisible(false)} className="notification-dropdown__close" />,
    clarnium: <CloseIcon onClick={() => setIsVisible(false)} className="notification-dropdown__close" />,
    inex: <CloseIconInex onClick={() => setIsVisible(false)} className="notification-dropdown__close" />,
    insta: <CloseIconInsta onClick={() => setIsVisible(false)} className="notification-dropdown__close" />,
    coinera: <CloseIconCoinera onClick={() => setIsVisible(false)} className="notification-dropdown__close" />,
  }

  const bellIcon = {
    cpay: <TransNotifIcon onClick={() => setIsVisible(true)} />,
    nfg: <TransNotifIcon onClick={() => setIsVisible(true)} />,
    finvaro: <TransNotifIcon onClick={() => setIsVisible(true)} />,
    clarnium: <TransNotifIcon onClick={() => setIsVisible(true)} />,
    inex: <TransNotifIconInex onClick={() => setIsVisible(true)} />,
    insta: <TransNotifIconInsta onClick={() => setIsVisible(true)} />,
    coinera: <TransNotifIconCoinera onClick={() => setIsVisible(true)} />,
  }

  const hasNewNotification = useMemo(() => {
    if (notification?.entities?.length > 0) {
      const isNotRead = notification?.entities?.filter(item => !item?.isRead);
      if (isNotRead?.length > 0) {
        return isNotRead?.map(item => item?.id)
      } else {
        return [];
      }
    }
  }, [notification]);

  useEffect(() => {
    if (isVisible && hasNewNotification?.length > 0 && merchantId) {
      patchTransactionNotifications(merchantId, {
        notifications: hasNewNotification
      });

      setTimeout(() => {
        getTransactionNotification(merchantId, { page: 1 });
      }, 1000);
    }
  }, [isVisible, merchantId]);

  useEffect(() => {
    if (!isVisible && merchantId && notification?.entities?.length !== 0) {
      getTransactionNotification(merchantId, { page: 1 });
    }
  }, [isVisible, merchantId])

  return (
    <div className={`notification notification-${identity}`}>
      <Dropdown
        trigger="click"
        placement="bottomCenter"
        visible={isVisible}
        onVisibleChange={visibilityState => setIsVisible(visibilityState)}
        overlay={
          <div className={`notification-dropdown notification-dropdown-${identity}`}>
            <div className={`notification-dropdown__title notification-dropdown__title-${identity}`}>{t('notification.title')}</div>
            {closeIcon[identity]}
            {notification?.entities?.length > 0 ? (
                <>
                  {notification?.entities?.map((item, index) => (
                    <NotificationBlock key={index} item={item} />
                  ))}
                </>
            ) : (
              <div className={`notification-dropdown__empty notification-dropdown__empty-${identity}`}>{t('notification.empty')}</div>
            )}

            {notification?.pages > 1 && notification?.page < notification?.pages && (
              <Button type="primary" onClick={() => getTransactionNotification(merchantId, { page: notification?.page + 1 })}>{t('notification.load')}</Button>
            )}
          </div>
        }
      >
        <div className="notification__center">
          {bellIcon[identity]}
          {notification?.entities?.isNew || hasNewNotification?.length > 0 && <div className="notification__dot"></div>}
        </div>
      </Dropdown>
    </div>
  )
};

const mapStateToProps = state => ({
  notification: state.transactions.notifications,
  merchantId: state.transactions.merchantId,
});

const mapDispatchToProps = dispatch => ({
  getTransactionNotification: getTransactionNotification(dispatch),
  patchTransactionNotifications: patchTransactionNotifications(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(TransactionNotification);

